/** Open a URL in the Telegram in-app browser (falls back to a new tab). */
export function openLink(url: string) {
  const wa = window.Telegram?.WebApp;
  if (wa?.openLink) wa.openLink(url);
  else window.open(url, '_blank');
}

/** Legal document URLs opened from the Profile screen.
 *  TODO: replace with the real Terms / Privacy URLs (provided by the customer). */
export const LINKS = {
  terms: 'https://asiacrypto.online/terms',
  privacy: 'https://asiacrypto.online/privacy',
} as const;
